export default __webpack_public_path__ + "static/media/saint-cloud2.98596351.jpg";